
const ECustomSettings = [
    {
        company: 'Viventium',
        description: {
            name: "viventium",
            realName: "Viventium Setting"
        }
    },
    {
        company: 'QuickPay',
        description: {
            name: "quickpay",
            realName: "Quickpay Setting"
        }
    },
    {
        company: 'Jamis',
        description: {
            name: "jamis",
            realName: "Jamis Setting"
        }
    },
    {
        company: 'Arbor',
        description: {
            name: "Arbor Setting",
            realName: "Arbor Setting"
        }
    },
    {
        company: 'GeoTab',
        description: {
            name: "GeoTab Setting",
            realName: "GeoTab Setting"
        }
    },
    {
        company: 'EasyScheduling',
        description: {
            name: "Easy Scheduling",
            realName: "Easy Scheduling Setting"
        }
    },
    {
        company: 'Adrenalin',
        description: {
            name: "adrenalin",
            realName: "Adrenalin Setting"
        }
    },
    {
        company: 'Xero',
        description: {
            name: "xero",
            realName: "Xero Setting"
        }
    },
    {
        company: 'OnShift',
        description: {
            name: "onshift",
            realName: "Onshift Setting"
        }
    },
    {
        company: 'DisconnectedDevices',
        description: {
            name: "disconnectedDevices",
            realName: "Disconnected Devices"
        }
    },
    {
        company: 'ReportsEmail',
        description: {
            name: "reportsEmail",
            realName: "Reports Email"
        }
    },
    {
        company: 'ExportFtpPush',
        description: {
            name: "ExportFtpPush",
            realName: "Export to FTP"
        }
    }
]
export default ECustomSettings;




// WEBPACK FOOTER //
// ./src/utils/ECustomSettings.js